export enum AcuteTCMRGrade {
    GradeIA = 0,
    GradeIB = 1,
    GradeIIA = 2,
    GradeIIB = 3,
    GradeIII = 4
}